import { Segmented, message, Popover } from "antd";
import { useEffect, useMemo, useState, useContext, useRef } from "react"
import API from '@api/api'
import Utils from '@utils/utils'
import styles from './index.module.scss'
import markIcon from '@assets/images/svgIcon/markIcon.svg'
import freeIcon from '@assets/images/svgIcon/freeIcon.svg'
import { LeftOutlined, RightOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import eventBus from "@utils/eventBus"
import { AppContext } from '@utils/AppContext';
import { SELECT_ORG_TYPE } from '@utils/CONST';



const options = [
    { label: '个人月卡', value: 0 },
    { label: '个人年卡', value: 1 },
    { label: <span className={styles.batchImagesTag}>企业套餐</span>, value: 2 },
    // { label: '定制解决方案', value: 3 },
]
const options2 = [
    { label: <span className={styles.batchImagesTag}>企业套餐</span>, value: 2 },
    // { label: '定制解决方案', value: 3 },
]

const MemberPackage = (props) => {
    const { globalUser, globalOrgInfo, setPayOrderInfo, payOrderInfo } = useContext(AppContext);
    const [type, setType] = useState(globalOrgInfo?.current?.id ? 2 : 0)
    const [plansList, setPlansList] = useState([{
        level: "basic",
        currentLevel: 1,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        discountPrice: '48',
        convert: '1,000虹豆 （1虹豆≈0.048）',
        imgCount: 100,
        singlePrice: 0.48,
        unit: "Month",
        powerList: ['每日登录赠送积分', '高清下载']
    }, {
        level: "pro",
        currentLevel: 2,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '5,000虹豆 （1虹豆≈0.037）',
        imgCount: 500,
        singlePrice: 0.48,
        unit: "Month",
        powerList: ['每日登录赠送积分', '高清下载', '支持2台设备同时在线']
    }, {
        level: "max",
        currentLevel: 3,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '20,000虹豆 （1虹豆≈0.024）',
        imgCount: 2000,
        singlePrice: 0.48,
        selected: true,
        unit: "Month",
        powerList: ['每日登录赠送积分', '高清下载', '支持4台设备同时在线', '专属1v1客服支持']
    }, {
        level: "ultra",
        currentLevel: 4,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '40,000虹豆 （1虹豆≈0.022）',
        imgCount: 4000,
        singlePrice: 0.48,
        unit: "Month",
        powerList: ['每日登录赠送积分', '高清下载', '支持6台设备同时在线', '专属1v1客服支持']
    }])

    const [yearPlansList, setYearPlansList] = useState([{
        level: "max",
        currentLevel: 3,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '20,000虹豆 （1虹豆≈0.024）',
        imgCount: 2000,
        singlePrice: 0.48,
        unit: "Year",
        powerList: ['每日登录赠送积分', '高清下载', '支持4台设备同时在线', '专属1v1客服支持']
    }, {
        level: "ultra",
        currentLevel: 4,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '40,000虹豆 （1虹豆≈0.022）',
        imgCount: 4000,
        singlePrice: 0.48,
        unit: "Year",
        powerList: ['每日登录赠送积分', '高清下载', '支持6台设备同时在线', '专属1v1客服支持']
    }])

    const [teamPlansList, setTeamPlansList] = useState([{
        level: "team",
        currentLevel: 5,
        title: 'PSAI 企业版 Pro',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        convert: '1虹豆≈0.026',
        unit: "Year",
        customize: 2,
        powerList: ['高品质生成', '优先出图权益', '线上培训', '专属客服']
    }, {
        level: "teamBasic",
        selected: true,
        currentLevel: 6,
        config: true,
        title: 'PSAI 企业版 Max',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        customize: true,
        unit: "Year",
        convert: '1虹豆≈0.017',
        customize: 3,
        discount: [9, '.2折'],
        powerList: ['高品质生成', '优先出图权益', '线上培训', '专属客服', '品类专项训练']
    }, {
        level: "teamPro",
        currentLevel: 6,
        config: true,
        title: 'PSAI 企业版 Max',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        customize: true,
        unit: "Year",
        convert: '1虹豆≈0.017',
        customize: 5,
        discount: [8, '.5折'],
        powerList: ['高品质生成', '优先出图权益', '线上培训', '专属客服', '品类专项训练', '联合营销机会']
    }, {
        level: "teamMax",
        currentLevel: 6,
        config: true,
        title: 'PSAI 企业版 Max',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        customize: true,
        unit: "Year",
        convert: '1虹豆≈0.017',
        customize: 10,
        discount: [7, '.8折'],
        powerList: ['高品质生成', '高优先级', '线上培训', '专属技术顾问', '品类专项训练', '联合营销机会', '线下沙龙']
    }, {
        level: "teamUltra",
        currentLevel: 6,
        config: true,
        title: 'PSAI 企业版 Max',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        customize: true,
        unit: "Year",
        convert: '1虹豆≈0.017',
        customize: 20,
        discount: [7, '.1折'],
        powerList: ['高品质生成', '最高优先级', '线上培训', '专属技术顾问', '品类专项训练', '联合营销机会', '线下沙龙']
    }])

    const memberLevel = useMemo(() => {
        return (globalUser?.membership?.level && globalUser?.membership?.level != -100) ?
            globalUser?.membership?.level : 0
    }, [globalUser])


    const onPayedClick = (id, currentLevel, level) => {
        const status = Utils.checkLoginStatus(() => onPayedClickFun(id, currentLevel, level))
        if (!status) return
        onPayedClickFun(id, currentLevel, level)
    }

    const onPayedClickFun = (id, currentLevel, level) => {
        // if (currentLevel < memberLevel) {
        //     message.warning('您当前会员等级已高于该等级！')
        //     return
        // }
        // if (currentLevel == 6) {
        //     const teamMax = teamPlansList.find(item => item.level == level);
        //     if (!teamMax) return;
        //     setPayOrderInfo({
        //         ...payOrderInfo,
        //         diyPower: teamMax.powerAmount,
        //         diyMember: teamMax.supportMembers,
        //         skuId: id,
        //         orgId: globalOrgInfo?.current.id,
        //     })
        // } else {
        setPayOrderInfo({
            ...payOrderInfo,
            skuId: id,
            orgId: globalOrgInfo?.current.id,
        })
        // }

        setTimeout(() => {
            if (globalOrgInfo?.isPersonal && (currentLevel == 5 || currentLevel == 6) && globalOrgInfo?.orgList.length > 1) {
                // 个人用户购买企业套餐且有多个企业时，打开选择企业弹窗
                eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.BUYORG })
            } else {
                // 其他情况下直接发起支付
                eventBus.emit('pc_pay')
            }
        }, 30)
    }

    const getListPlan = () => {
        API.getListPlan({}).then((res) => {
            if (res.code == 0) {
                const updatedPlansList = [...plansList];
                const updatedYearPlansList = [...yearPlansList];
                const updatedTeamYearPlansList = [...teamPlansList];

                res.data.forEach(item => {
                    const planIndex = updatedPlansList.findIndex(plan => plan.level === item.level && plan.unit === item.unit);
                    const yearPlanIndex = updatedYearPlansList.findIndex(plan => plan.level === item.level && plan.unit === item.unit);
                    const teamYearPlanIndex = updatedTeamYearPlansList.findIndex(plan => plan.level === item.level && plan.unit === item.unit);

                    if (planIndex !== -1) {
                        updatedPlansList[planIndex].zhTitle = item.description;
                        updatedPlansList[planIndex].id = item.id;
                        updatedPlansList[planIndex].enTitle = item.name;
                        updatedPlansList[planIndex].price = globalUser?.payedUser === 0 ? item.firstBuyPrice : item.price;
                        updatedPlansList[planIndex].imgCount = item.powerAmount / 10;
                        updatedPlansList[planIndex].singlePrice = (globalUser?.payedUser === 0 && item.firstBuyPrice == 19.9) ? 0.199 : Math.ceil(item.uPrice) / 100;
                        updatedPlansList[planIndex].convert = `${item.powerAmount}虹豆 （1虹豆≈${(globalUser?.payedUser === 0 && item.firstBuyPrice == 19.9) ? 0.0199 : Math.ceil(item.uPrice) / 1000}）`
                    }
                    if (yearPlanIndex !== -1) {
                        updatedYearPlansList[yearPlanIndex].zhTitle = item.description;
                        updatedYearPlansList[yearPlanIndex].id = item.id;
                        updatedYearPlansList[yearPlanIndex].enTitle = item.name;
                        updatedYearPlansList[yearPlanIndex].price = globalUser?.payedUser === 0 ? item.firstBuyPrice : item.price;
                        updatedYearPlansList[yearPlanIndex].imgCount = item.powerAmount / 10;
                        updatedYearPlansList[yearPlanIndex].singlePrice = Math.ceil(item.uPrice) / 100;
                        updatedYearPlansList[yearPlanIndex].convert = `${item.powerAmount}虹豆 （1虹豆≈${Math.ceil(item.uPrice) / 1000}）`
                    }
                    if (teamYearPlanIndex !== -1) {
                        updatedTeamYearPlansList[teamYearPlanIndex].zhTitle = item.description;
                        updatedTeamYearPlansList[teamYearPlanIndex].id = item.id;
                        updatedTeamYearPlansList[teamYearPlanIndex].enTitle = item.name.substring(0, item.name.lastIndexOf(" "));
                        updatedTeamYearPlansList[teamYearPlanIndex].price = globalUser?.payedUser === 0 ? item.firstBuyPrice : item.price;
                        updatedTeamYearPlansList[teamYearPlanIndex].imgCount = item.powerAmount / 10;
                        updatedTeamYearPlansList[teamYearPlanIndex].singlePrice = Math.ceil(item.uPrice) / 100;
                        updatedTeamYearPlansList[teamYearPlanIndex].powerAmount = item.powerAmount;
                        updatedTeamYearPlansList[teamYearPlanIndex].supportMembers = item.supportMembers;
                        updatedTeamYearPlansList[teamYearPlanIndex].concurrentSku = item.concurrentSku;
                    }
                    // if (yearPlanIndex !== -1) {
                    //     updatedYearPlansList[yearPlanIndex].title = item.name;
                    //     updatedYearPlansList[yearPlanIndex].id = item.id;
                    //     updatedYearPlansList[yearPlanIndex].price = Math.ceil(item.price);
                    //     updatedYearPlansList[yearPlanIndex].imgCount = item.powerAmount / 10;
                    //     updatedYearPlansList[yearPlanIndex].singlePrice = Math.ceil(item.uPrice) / 100;
                    //     updatedYearPlansList[yearPlanIndex].accountCount = item.supportMembers;
                    //     updatedYearPlansList[yearPlanIndex].initAccountCount = item.supportMembers;
                    //     updatedYearPlansList[yearPlanIndex].beanCount = item.powerAmount;
                    //     updatedYearPlansList[yearPlanIndex].initBeanCount = item.powerAmount;
                    // }
                });

                setPlansList(updatedPlansList);
                setYearPlansList(updatedYearPlansList);
                setTeamPlansList(updatedTeamYearPlansList);
            }
        })
    }

    useEffect(() => {
        getListPlan()
    }, [])

    useEffect(() => {
        const teamMax = yearPlansList.find(item => item.config);
        if (!teamMax) return;
        setPayOrderInfo({
            ...payOrderInfo,
            diyPower: teamMax.beanCount,
            diyMember: teamMax.accountCount,
        })
    }, [yearPlansList.find(item => item.config)?.beanCount, yearPlansList.find(item => item.config)?.accountCount]);


    // 点击增减函数
    const handleAdjust = (index, field, type) => {
        setYearPlansList(prev => {
            const newList = [...prev];
            const item = { ...newList[index] };

            item.beanCount = Number(item.beanCount);
            item.accountCount = Number(item.accountCount);
            item.price = Number(item.price);

            if (field === 'beanCount') {
                if (type === 'add') {
                    item.beanCount += 10000;
                    item.price += 170;
                } else if (type === 'minus' && item.beanCount > (item.initBeanCount ?? item.beanCount)) {
                    item.beanCount -= 10000;
                    item.price -= 170;
                }
            }

            if (field === 'accountCount') {
                if (type === 'add') {
                    item.accountCount += 1;
                    item.price += 288;
                } else if (type === 'minus' && item.accountCount > 6) { //最低6个席位
                    item.accountCount -= 1;
                    item.price -= 288;
                }
            }

            newList[index] = item;
            return newList;
        });
    };

    const validityDay = useMemo(() => {
        const today = new Date();
        const future = new Date(today);
        const t = Number(type); // 转数字，避免 '1' !== 1

        if (t === 0) {
            future.setDate(today.getDate() + 30);
        } else if (t === 1 || t === 2) {
            future.setDate(today.getDate() + 365);
        }

        const year = future.getFullYear();
        const month = String(future.getMonth() + 1).padStart(2, '0');
        const day = String(future.getDate()).padStart(2, '0');
        return `${year}年${month}月${day}日`;
    }, [type]);




    const personalItem = (item, index) => (
        <div
            onClick={() => onPayedClick(item.id, item.currentLevel, item.level)}
            className={`${styles.planItem} ${item.selected ? styles.planItemSelected : ''}`}
            key={index}>
            <p className={styles.zhTitle}>{item.enTitle}</p>
            <p className={styles.enTitle}>{item.zhTitle}</p>
            {
                (item.discountPrice && globalUser?.payedUser === 0) ? <p className={styles.price2}>
                    <span style={{ textDecoration: 'line-through' }}>{item.discountPrice}</span>&nbsp;
                    <span>
                        <span style={{ fontSize: '12px', fontWeight: 400 }}>¥</span>
                        <span style={{ color: '#FF4949' }}>{item.price}</span>
                        <span style={{ fontSize: '12px', fontWeight: 400 }}>/{item.unit == "Year" ? '年' : '月'}</span></span>
                </p> : <p className={styles.price}>
                    <span>¥<span>{item.price}</span> /{item.unit == "Year" ? '年' : '月'}</span>
                </p>
            }

            <p className={styles.convert}>{item.convert}</p>
            <p className={styles.imgCount}>最多可生成 <span>{item.imgCount}张</span> 图片</p>
            <p className={styles.singlePrice}>单张图片价格低至 <span>{item.singlePrice}元</span></p>
            <div
                className={`${styles.buyBtn} ${item.selected ? styles.selected : ''}`}>立即购买</div>
            <div className={styles.powerList}>
                {item.powerList.map((power, index) => (
                    <p key={index}><img src={markIcon} alt="" />{power}</p>
                ))}
            </div>
        </div>
    )
    const teamItem = (item, index) => (
        <div
            onClick={() => onPayedClick(item.id, item.currentLevel, item.level)}
            className={`${styles.planItem} ${item.selected ? styles.planItemSelected : ''}`}
            key={index}>
            <p className={styles.zhTitle}>{item.enTitle}</p>
            <p className={`${styles.enTitle} ${styles[`enTitle${index}`]}`}>
                {item.zhTitle}
                {
                    item.discount && <span className={styles.enTitleIcon}><span>{item.discount?.[0]}</span>{item.discount?.[1]}</span>
                }
            </p>
            <p className={styles.price}>
                <span>¥<span>{Math.ceil(item.price)}</span> /{item.unit == "Year" ? '年' : '月'}</span>
            </p>
            <p className={styles.convert}>折算算每月 {Number(item.price / 12).toFixed(2)}</p>
            <p className={styles.teamPowerAmount}><span>{item.powerAmount}</span> 虹豆，<span>{item.supportMembers == -1 ? '无限' : item.supportMembers}</span> 个席位</p>
            <p className={styles.customize}>首购加赠 <span>{item.customize}</span> 个定制模特
                <Popover
                    placement="top"
                    content={
                        <>
                            <img
                                style={{ width: '120px', height: '120px' }}
                                src={Utils.qrcodeSales}
                                alt="扫码联系我们"
                            />
                            <p style={{ textAlign: 'center', marginTop: '8px' }}>添加客服微信领取</p>
                            <p style={{ textAlign: 'center', color: '#96A2B1', fontSize: '12px' }}>*仅首次购买该套餐可享</p>
                        </>
                    }
                >
                    <ExclamationCircleOutlined style={{ marginLeft: '8px', color: '#000812' }} />
                </Popover>
            </p>
            <div className={`${styles.buyBtn} ${item.selected ? styles.selected : ''}`} style={{ margin: '12px 0' }} >立即购买</div>
            <p className={styles.tips}>最多生成 <span>{item.powerAmount / 100000}万张</span>, 单图约 <span>{item.singlePrice.toFixed(2)}元</span></p>
            <p className={styles.tips} style={{ marginBottom: '6px' }} >同时可传 <span>{item.concurrentSku}个</span>素材</p>
            <div className={styles.powerList} style={{ marginTop: 0 }}>
                {item.powerList.map((power, index) => (
                    <p key={index}><img src={markIcon} alt="" />{power}</p>
                ))}
            </div>
        </div>
    )


    // 滚动按钮
    const scrollRef = useRef(null)
    const [position, setPosition] = useState('left')
    const handleScrollRight = () => {
        setPosition('right')
        const box = scrollRef.current
        box.scrollTo({
            left: box.scrollWidth,
            behavior: 'smooth'
        })
    }
    const handleScrollLeft = () => {
        setPosition('left')
        const box = scrollRef.current
        box.scrollTo({
            left: 0,
            behavior: 'smooth'
        })
    }


    return (
        <div className={styles.MemberPackage}>
            {
                !globalOrgInfo?.current?.id && <Segmented
                    className={!globalOrgInfo?.isPersonal ? `${styles.Segmented} ${styles.Segmented2}` : styles.Segmented}
                    value={type}
                    options={globalOrgInfo?.current?.id ? options2 : options}
                    onChange={(value) => { setType(value); setPosition('left') }} />
            }

            <div className={styles.planList}>
                {
                    type === 0 ? plansList.map((item, index) => (
                        personalItem(item, index)
                    )) : type === 1 ? <div style={{ width: '536px', display: 'flex', justifyContent: 'space-between', margin: '0 auto' }}>
                        {
                            yearPlansList.map((item, index) => (
                                personalItem(item, index)
                            ))
                        }
                    </div>
                        : type === 2 ? <div className={styles.carouselWrapper}>
                            {position != 'left' && <div className={styles.leftBtn} onClick={handleScrollLeft}><LeftOutlined /></div>}
                            {position != 'left' && <div className={styles.leftShadow}></div>}
                            <div className={styles.carousel} ref={scrollRef}>
                                <div className={styles.carouselWrapperBox}>
                                    {teamPlansList.map((item, index) => teamItem(item, index))}
                                </div>
                            </div>
                            {position != 'right' && <div className={styles.rightShadow}></div>}
                            {position != 'right' && <div className={styles.rightBtn} onClick={handleScrollRight}><RightOutlined /></div>}
                        </div>
                            : <>
                                {/* {
                                    yearPlansList.map((item, index) => (
                                        <div
                                            className={`${styles.planItemYear} ${item.customize ? styles.planItemYearSelected : ''}`}
                                            key={index}>
                                            <p className={styles.title}>{item.title}</p>
                                            <p className={styles.price}>¥<span>{item.price}</span> /年</p>
                                            <p className={styles.beanCount}>
                                                {item.config && <MinusCircleFilled
                                                    className={styles.minusIcon}
                                                    style={{ color: item?.beanCount == 240000 ? '#EEEEEE' : '#52A8FF ' }}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAdjust(index, 'beanCount', 'minus');
                                                    }} />}
                                                <span className={`${styles.beanNum} ${!item.config ? styles.beanNumPro : ''}`}>{item.beanCount}</span>
                                                {item.config && <PlusCircleFilled
                                                    className={styles.plusIcon}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAdjust(index, 'beanCount', 'add');
                                                    }} />}
                                                虹豆
                                                <span className={styles.beanDesc}>{item.convert}</span>
                                            </p>

                                            <p className={styles.beanCount}>
                                                {item.config && <MinusCircleFilled
                                                    style={{ color: item.accountCount == 6 ? '#EEEEEE' : '#52A8FF ' }}
                                                    className={styles.minusIcon}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAdjust(index, 'accountCount', 'minus');
                                                    }} />}
                                                <span className={`${styles.beanNum} ${!item.config ? styles.beanNumPro : ''}`}>{item.accountCount}</span>
                                                {item.config && <PlusCircleFilled
                                                    className={styles.plusIcon}
                                                    onMouseDown={(e) => e.preventDefault()}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAdjust(index, 'accountCount', 'add');
                                                    }} />}
                                                个账号
                                            </p>
                                            <div className={styles.buyBtn} onClick={() => onPayedClick(item.id, item.currentLevel, item.level)}>立即购买</div>
                                            <p className={styles.imgCount}>最多可生成 <span>{item.imgCount}张</span> 图片</p>
                                            <p className={styles.singlePrice}>单张图片价格低至 <span>{item.singlePrice}元</span></p>
                                            <div className={styles.powerList}>
                                                {item.powerList.map((power, index) => (
                                                    <p key={index}><img src={markIcon} alt="" />{power}</p>
                                                ))}
                                            </div>
                                        </div>
                                    ))
                                } */}
                                <div className={styles.planItemYearLast}>
                                    <p className={styles.title1}>企业解决方案</p>
                                    <img src={freeIcon} alt="" />
                                    <p className={styles.title2}>一站式交付</p>
                                    <p className={styles.title3}>品牌资产定制</p>
                                    <p className={styles.desc} style={{ marginTop: 24 }}>批量制作·模特定制·套餐定制·按需选择/调整</p>
                                    <p className={styles.desc}>VIP专属企业服务</p>
                                    <img className={styles.qrcodeSales} src={Utils.qrcodeSales} alt="扫码联系我们" />
                                    <p className={styles.desc}>添加PSAI专员微信</p>
                                    <p className={styles.desc}>为您提供最佳的策略和方案</p>
                                </div>
                            </>
                }
            </div>
            <p className={styles.planValidity}>会员方案有效期为{
                type === 0 ? '30天' : '365天'}，现在购买有效期至{validityDay}</p>
        </div>
    )
}

export default MemberPackage